var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import mapProps from "./mapProps";
import resolveValue from "./utils/resolveValue";
export function withProps(createProps) {
    return mapProps(function (props) { return (__assign({}, props, resolveValue(createProps, props))); });
}
export default withProps;

//# sourceMappingURL=withProps.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/withProps.js
// module id = 79
// module chunks = 0